export default __webpack_public_path__ + "static/media/home-1.3f03014d.svg";